import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function MidCTA() {
  return <section className="py-20 px-4 bg-cream border-y border-cream-dark" data-id="element-234">
      <div className="max-w-3xl mx-auto text-center" data-id="element-235">
        <h2 className="text-3xl font-serif font-bold text-green mb-8" data-id="element-236">
          Todo lo que recibís en un solo lugar
        </h2>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gold/30 mb-8 inline-block text-left" data-id="element-237">
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3" data-id="element-238">
            {['Tomo 1 — Las Bases del Taller Profesional', 'Tomo 2 — De la Materia Prima a la Conservación', 'Tomo 3 — Tecnología de Lácteos y Cárnicos', 'Tomo 4 — Del Envase al Consumidor', 'Tomo 5 — Del Taller al Emprendimiento', 'Banco de paquete de actividades Adicionales', 'Banco de Evaluaciones', 'Recetario Técnico de Referencia', 'Proyectos Productivos Extra', 'Acceso inmediato', 'Pago único', 'Garantía de 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-239">
                <Check size={16} className="text-terracota shrink-0" data-id="element-240" />
                <span className="text-sm text-ink font-medium" data-id="element-241">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="mb-8" data-id="element-242">
          <p className="text-slate mb-2" data-id="element-243">Todo por un único pago de:</p>
          <p className="text-5xl font-bold text-green mb-2" data-id="element-244">USD 19,90</p>
          <p className="text-sm text-terracota font-medium" data-id="element-245">
            Precio promocional disponible por tiempo limitado
          </p>
        </div>

        <Button href="#pricing" variant="green" className="mb-4" data-id="element-246">
          QUIERO MI MEGA PACK AHORA
        </Button>

        <div className="flex justify-center gap-4 text-xs text-slate font-medium" data-id="element-247">
          <span data-id="element-248">🔒 Pago seguro</span>
          <span data-id="element-249">⚡ Acceso inmediato</span>
          <span data-id="element-250">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}